import { useQuery } from "@tanstack/react-query";
import { Link, useParams } from "react-router-dom";

import PageContent from "../page-content";
import { requireLogin } from "../../../security";
import { productQueryOptions } from "../../../data/queries/products";
import { Spinner } from "../../../ui";

function Confirmation() {
  const { uid } = useParams();
  const { data: product, isLoading } = useQuery(productQueryOptions(uid || ""));

  if (isLoading || !product) {
    return <Spinner />;
  }
  return (
    <>
      {product.status === "order" && (
        <PageContent
          title="Commande validée"
          description="Votre commande a été enregistrée avec succès."
        >
          <p>
            Votre commande a été effectuée avec succès. Un email de confirmation vous sera envoyé
            dans quelques secondes.
          </p>
          <p>
            Vous serez informé de l'évolution de votre commande jusqu'à la livraison de votre
            commande.
          </p>
          <p>
            Nous éspèrons vous revoir bientôt sur notre site pour péréniser d'autres souvenirs
            impérissables.
          </p>
          <p>
            Pour passer une nouvelle commande, c'est <Link to="/">par ici que ça se passe</Link>.
          </p>
        </PageContent>
      )}
      {product.status === "draft" && (
        <PageContent
          title="En cours de validation..."
          description="Veuillez patienter pendant que nous validons votre commande."
        />
      )}
    </>
  );
}

export default requireLogin()(Confirmation);
